import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import iView from 'iview';
import TreeTable from 'tree-table-vue';
import './index.less';
import './assets/icons/iconfont.css';
import VueDND from 'awe-dnd';//拖拽排序
import config from '@/config';
import Grid from 'vue-js-grid';
import filters from './libs/filters';
import Print from 'vue-print-nb'

Vue.prototype.$config = config;

Vue.config.productionTip = false;
Vue.use(iView, {
    size: 'large'
});
Vue.use(TreeTable);
Vue.use(VueDND);
Vue.use(Grid);
Vue.use(Print);

for (let [key, value] of Object.entries(filters)) {
    Vue.filter(key, value);
}

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
